module.exports = __webpack_public_path__ + "static/media/projects_image.3cdc8120.svg";